import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { incidentService } from '@iso/services';
import IntlMessages from '@iso/components/utility/intlMessages';
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

const { TextArea } = Input;

const AddActivityModal = ({ visible, onCancel, onSaved, incident, activity }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [attachmentIds, setAttachmentIds] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  useEffect(() => {
    console.log('activity:', activity);
    if (activity) {
      form.setFieldsValue({
        ...activity
      });

      setUploadFiles(
        activity.attachments?.map((attachment, index) => ({
          id: attachment.id,
          uid: attachment.id,
          name: attachment.url.split('/').pop(),
          url: attachment.full_path,
          thumbUrl: attachment.full_path,
        }))
      );
    } else {
      form.resetFields();
      setUploadFiles([]);
      setAttachmentIds([]);
    }
  }, [activity, form]);

  const handleUploadChange = (response) => {
    if (response.file.status === 'done') {
      setAttachmentIds([...attachmentIds, response.file.response.attachment.id]);
    }

    setUploadFiles([...response.fileList]);
  };

  const handleRemoveAttachment = (file) => {
    const removedAttachmentId = file.response?.attachment?.id ?? file.uid;
    setAttachmentIds(attachmentIds.filter(id => id !== removedAttachmentId));
  };

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      setLoading(true);
      try {
        await incidentService.createActivity({
          ...values,
          incident_id: incident.id,
          attachment_ids: attachmentIds,
        });
        onSaved();
      } catch (error) {
        console.error('There was an error creating the activity!', error);
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={
        activity
        ? <IntlMessages id="incidentPage.activity.modal.viewActivity" />
        : <IntlMessages id="incidentPage.activity.modal.addActivity" />
      }
      footer={[
        <Button key="back" onClick={onCancel} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        !activity ? (
          <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}
            style={{ backgroundColor: '#0B2A1B', borderColor: '#0B2A1B' }}>
            {<IntlMessages id="propertyPage.modal.save" />}
          </Button>
        ) : null,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label={<IntlMessages id="incidentPage.activity.form.title" />}
          rules={[{ required: true, message: 'Please enter the title!' }]}
        >
          <Input readOnly={activity} />
        </Form.Item>
        <Form.Item
          name="description"
          label={<IntlMessages id="incidentPage.activity.form.description" />}
          rules={[{ required: true, message: 'Please enter the description!' }]}
        >
          <TextArea rows={4} readOnly={activity} />
        </Form.Item>
        <Form.Item
          label={<IntlMessages id="incidentPage.activity.form.attachments" />}
        >
          <Upload
            action={apiEndpoint.attachments}
            headers={authHeader(true)}
            listType="picture"
            name="Attachment[file]"
            fileList={uploadFiles}
            multiple={true}
            onChange={handleUploadChange}
            data={{ type: 'incident_activity', storage: 'filesystem' }}
            onRemove={handleRemoveAttachment}
            disabled={activity}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddActivityModal;
